<template>
  <div>
    <div v-for="(item, i) in subjectCombine" :key="i" style="display: inline;">
      <div v-if="subject_combine_id.indexOf(item.id) > -1" :class="{
        act: nav_id == item.id ? true : false,
      }" class="subjectCard">
        {{ item.name }}
        <p>匹配率：院校 {{ Math.trunc(item.college_percent) }}% 专业 {{ Math.trunc(item.specialty_percent) }}%</p>
      </div>
    </div>

    <div v-for="(item, i) in subjectCombine" :key="i + 12" style="display: inline;">
      <div v-if="subject_combine_id.indexOf(item.id) < 0" :class="{
        act: nav_id == item.id ? true : false,
        hidden_bg: true
      }" class="subjectCard">
        {{ item.name }}
        <p>匹配率：院校 {{ Math.trunc(item.college_percent) }}% 专业 {{ Math.trunc(item.specialty_percent) }}%</p>
      </div>
    </div>


    <div class="remarks-a">
      注：根据河南省各个高中的实际情况，各个高中开通的选科组合可能不同，你可通过设置限定选科组合的功能设定你学校开通的选科组合，从中间确定自己最终要选择的组合
    </div>

    <div class="title">
      <el-row>
        <el-col :span="4">推荐组合:{{ combineData.name }}</el-col>
        <el-col :span="6">匹配率:院校 {{ Math.trunc(combineData.college_percent) }}% 专业 {{
          Math.trunc(combineData.specialty_percent)
        }}%</el-col>
        <el-col :span="4">意向院校:
          <el-dropdown szie="small ">
            <span v-if="choosCollegeList" style="font-size: 16px;margin-left: 10px;">
              {{ choosCollegeList.length }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <span v-else style="font-size: 16px;margin-left: 10px;">0</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, i) in choosCollegeList" :key="i">{{ item }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="4">意向专业(大类):
          <el-dropdown>
            <span v-if="categroyCode" style="font-size: 16px;margin-left: 10px;">
              {{ categroyCode.length }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <span v-else style="font-size: 16px;margin-left: 10px;">0</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, i) in category_list" :key="i">{{ item.specialty_name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="3" :offset="3"> <span style="color: #e45a01;" @click="saveChoose()">确定选科组合</span>
        </el-col>
      </el-row>
    </div>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="院校优先" name="first">
        <college-first :choosCollegeList="choosCollegeList" @chooseCollege="chooseCollege"></college-first>
      </el-tab-pane>

      <el-tab-pane label="专业优先" name="second">
        <specialty-first :categroyCode='categroyCode'
          @chooseSpecialtyCategory="chooseSpecialtyCategory"></specialty-first>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import CollegeFirst from "./college-first"
import SpecialtyFirst from "./specialty-first"
export default {
  name: '',
  data() {
    return {
      subjectCombine: [],
      nav_id: '',
      combineData: [],
      activeName: "first",
      choosCollegeList: [],
      category_list: [],
      categroyCode: [],
      subject_combine_id: [],
      tab_id: 0
    };
  },
  components: {
    CollegeFirst,
    SpecialtyFirst
  },
  created() {
    this.getSubectList()
    this.getUserCombineList()
  },

  methods: {
    getSubectList() {
      this.$fecth.post("xuanke/x_specialty/getSubjectCombine").then((res) => {
        this.subjectCombine = res
        this.getuserCombine()
      });
    },
    getuserCombine() {
      this.$fecth.post("xuanke/x_specialty/getUserSubjectCombine").then((res) => {
        this.subject_combine_id = res.subject_combine_id
        this.combineData = this.subjectCombine[res.subject_combine_id[0]]
        this.nav_id = res.subject_combine_id[0]
      });
    },

    getUserCombineList() {
      this.$fecth.post("xuanke/user_combine_list/getSchemeList").then((res) => {

        //已选择的院校数据
        this.choosCollegeList = res.college_list
        this.choosCollegeList = this.choosCollegeList == null ? [] : this.choosCollegeList

        //已选择的专业大类
        this.category_list = res.category_list
        if (this.category_list) {
          this.categroyCode = res.code_list
        } else {
          this.category_list = []
          this.categroyCode = []
        }
      });
    },



    chooseCollege(item) {
      let i = this.choosCollegeList.indexOf(item)
      if (i > -1) {
        this.choosCollegeList.splice(i, 1)
      } else {
        this.choosCollegeList.push(item)
      }
      this.saveChoose()
    },

    chooseSpecialtyCategory(item) {
      let i = this.categroyCode.indexOf(item.code_id)
      if (i > -1) {
        this.categroyCode.splice(i, 1)
        this.category_list.splice(i, 1)
      } else {
        this.categroyCode.push(item.code_id)
        this.category_list.push(item)
      }
      this.saveChoose()
    },

    saveChoose() {
      let data = {
        college_list: this.choosCollegeList,
        category_list: this.category_list,
        code_list: this.categroyCode
      }
      this.$fecth.post("xuanke/user_combine_list/saveSchemeChoose", data).then((res) => {
        if (res) {
          this.$notify({
            offset: 100,
            showClose: true,
            message: "保存成功",
            type: "success",
          });
          if (this.tab_id == 0) {
            this.getBestCollegeCombine()

          } else {
            this.getBestSpecialtyCombine()
          }
        }
      });
    },

    // 获取推荐概率
    getBestCollegeCombine() {
      this.$fecth.post("xuanke/user_combine_list/getBestCollegeCombine").then((res) => {
        if (res) {
          this.nav_id = res
          this.combineData = this.subjectCombine[res - 1]
        }
      });
    },

    getBestSpecialtyCombine() {
      this.$fecth.post("xuanke/user_combine_list/getBestSpecialtyCombine").then((res) => {
        if (res) {
          this.nav_id = res
          this.combineData = this.subjectCombine[res - 1]
        }
      });
    },

    handleClick(tab) {
      this.tab_id = tab.index
    }
  },
};
</script>

<style scoped lang='less'>
.subjectCard {
  display: inline-block;
  color: #702b1b;
  background: #fdf5ea;
  text-align: center;
  width: 193px;
  padding: 14px 0px;
  margin-top: 10px;
  margin-right: 6px;
  border-radius: 5px;
  font-size: 20px;
  letter-spacing: 2px;

  p {
    margin-top: 20px;
    font-size: 14px;
    letter-spacing: 0px;
  }
}

.act {
  // padding: 16px 56px;
  border: #edb290 1px solid;
  background: #f8d0b6;
}

.remarks-a {
  margin-top: 20px;
  padding: 10px 20px;
  line-height: 160%;
  color: #838381;
  background: #fdf5ea;
}

.title {
  color: #702b1b;
  padding: 0 40px;
  background: #fdf5ea;
  border-radius: 5px;
  line-height: 70px;
  margin: 20px 0;
  font-size: 18px;
  border: #edb290 1px solid;
  font-weight: 500;
}

.hidden_bg {
   *{
    padding: 0;
    margin: 0;
  }
  background: #e7e7e7 !important;
  color: #6e6e6e !important;
}
</style>
